import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { ListItemIcon, MenuItem, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useMenuContext } from 'pages/ParentHelper/components/History/hooks';
import { useParentHelperContext } from 'pages/ParentHelper/providers/ParentHelperProvider/hooks';
import { useSnackbarContext } from 'pages/ParentHelper/providers/SnackbarProvider/hooks';
import { SnackbarEnum } from 'pages/ParentHelper/providers/SnackbarProvider/types';
import { Menu as MenuWrapper } from 'shared/components/Menu';

import { ToggleFavorite } from './components/ToggleFavorite';
import { useSetFavoriteChat } from './hooks';

import type { FC } from 'react';

export const Menu: FC = () => {
  const { t } = useTranslation();
  const { onClose, anchorEl, open } = useMenuContext();
  const { onOpen: onOpenSnackbar } = useSnackbarContext();
  const { setDeletedChatId } = useParentHelperContext();
  const toggleFavoriteChat = useSetFavoriteChat();
  const currentChatId = anchorEl?.id || null;

  const onDeleteChat = useCallback(() => {
    setDeletedChatId(currentChatId);
    onOpenSnackbar(SnackbarEnum.Deleting);
    onClose();
  }, [currentChatId, onClose, onOpenSnackbar, setDeletedChatId]);

  return (
    <MenuWrapper
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <MenuItem dense onClick={toggleFavoriteChat}>
        <ToggleFavorite />
      </MenuItem>
      {/* // TODO: remove after adding Notistack */}
      <MenuItem dense onClick={onDeleteChat}>
        <ListItemIcon>
          <DeleteOutlineOutlinedIcon color="error" />
        </ListItemIcon>
        <Typography variant="inherit" color="error">
          {t('pages.parentHelper.history.menu.delete')}
        </Typography>
      </MenuItem>
    </MenuWrapper>
  );
};
